// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1DIyb","header":"Messages_header__28iNv"};